<!--  -->
<template>
  <div class="jh-big-file-upload">
    <el-upload
      ref="upload"
      class="upload"
      v-bind="$attrs"
      :action="UPLOAD_URL"
      :headers="headers"
      :data="fileData"
      :on-change="onChange"
      :on-exceed="onExceed"
      :on-progress="onProgress"
      :on-success="onSuccess"
      :on-error="onError"
      :before-upload="beforeUpload"
      multiple
      :limit="limit"
      :show-file-list="true"
      :file-list="value"
      list-type="picture-card"
    >
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }">
        <el-image
          fit="cover"
          style="height: 146px"
          class="el-upload-list__item-thumbnail"
          :src="file.url"
          v-loading="!(file.url && file.url.indexOf('WholeFileId') > -1)"
          alt=""
        ></el-image>
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleDownload(file)"
          >
            <i class="el-icon-download"></i>
          </span>
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <el-dialog append-to-body title="图片预览" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "jh-file-upload",
  props: {
    headers: {
      type: Object,
      default: () => {
        return { "Auth-User-Token": window.sessionStorage.token };
      }
    },
    limit: {
      type: Number,
      default: 10
    },
    value: {
      type: Array,
      default: () => []
    },
    uploadConfig: {
      type: Object,
      default: () => {
        return {
          compressDimension: "800x600"
        };
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    //是否在只有fileId回显时格式化回显数组
    format: {
      type: Boolean,
      default: true
    },
    //获取图片时的质量系数
    quality: {
      type: Number,
      default: 10
    },
    compressed: {
      type: Boolean,
      default: true
    },
    compressType: {
      type: String,
      default: "3"
    }
  },

  data() {
    return {
      UPLOAD_URL: "",
      fileTasks: {}, //上传队列
      fileData: {},
      dialogImageUrl: "",
      dialogVisible: false
    };
  },
  created() {
    this.UPLOAD_URL = this.getGlobalConfig().uploadURL + "/api/file/upload";
    console.log(this.uploadConfig);
  },
  watch: {
    value: {
      handler: function(newV, oldV) {
        //回显时如果文件已经有fileId 补全组件内需要的字段
        if (
          this.format &&
          newV &&
          newV.length > 0 &&
          !newV[0].id &&
          Object.keys(this.fileTasks).length === 0
        ) {
          let packList = newV.map(item => {
            if (item.fileId) {
              !item.id && (item.id = _.uniqueId());
              item.url =
                this.getGlobalConfig().uploadURL +
                "/api/file/downloadFile" +
                "?fileHashOrWholeFileId=" +
                item.fileId +
                "&compressType=" +
                this.compressType;
            }
            if (this.compressed) {
              item.url +=
                "&qualityType=" +
                (this.uploadConfig.dimensionRate || this.quality);
            }
            return item;
          });
          this.$emit("input", packList);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleRemove(file) {
      this.deleteFile(file, this.value.indexOf(file));
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      this.downloadFile(
        file.url.replace("&compressType=" + this.compressType, ""),
        file.name || "文件"
      );
    },
    /**
     * @description: 文件提醒
     * @param {*} files
     * @param {*} fileList
     * @return {*}
     * @author: Junchi Zhao
     */
    onExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.limit} 个文件`);
      for (const file of files) {
        console.log(this.value.indexOf(file));
        if (this.value.indexOf(file) > -1) {
          this.deleteFile(file, this.value.indexOf(file));
        }
      }
    },
    /**
     * @description: 获取文件
     * @param {*} file
     * @param {*} fileList
     * @return {*}
     * @author: Junchi Zhao
     */
    onChange(file, fileList) {
      if (file.status === "ready") {
        this.value.push(file);
        if (!this.fileTasks[file.uid]) {
          this.fileTasks[file.uid] = true;
        }
      }
    },
    /**
     * @description: 上传成功
     * @param {*} response
     * @param {*} file
     * @param {*} fileList
     * @return {*}
     * @author: Junchi Zhao
     */
    onSuccess(response, file, fileList) {
      if (response.retHead.code === "0000000") {
        file.url =
          this.getGlobalConfig().uploadURL +
          "/api/file/downloadFile" +
          "?fullfilename=" +
          file.name +
          "&fileHashOrWholeFileId=" +
          response.retBody.fileId +
          "&compressType=" +
          this.compressType;
        //如果开启显示压缩模式
        if (this.compressed) {
          file.url +=
            "&qualityType=" + (this.uploadConfig.dimensionRate || this.quality);
        }
        _.assign(file, response.retBody);
      } else {
        file.status = "fail";
        this.$message.error(file.name + "上传失败");
      }
      if (this.fileTasks[file.uid]) {
        _.unset(this.fileTasks, file.uid);
      }
      if (Object.keys(this.fileTasks).length === 0) {
        this.$emit("onSuccess", this.value);
      }
    },
    /**
     * @description: 上传失败
     * @param {*} err
     * @param {*} file
     * @param {*} fileList
     * @return {*}
     * @author: Junchi Zhao
     */
    onError(err, file, fileList) {
      this.$message.error(file.name + "上传失败");
      if (this.fileTasks[file.uid]) {
        _.unset(this.fileTasks, file.uid);
      }
    },
    beforeUpload(file) {
      this.fileData.aliases = file.name;
      this.fileData.compressType = this.compressType;
      if (this.uploadConfig && Object.keys(this.uploadConfig).length > 0) {
        _.assign(this.fileData, this.uploadConfig);
      }
    },
    /**
     * @description: 校验文件是否上传完毕
     * @param {*}
     * @return {*}
     * @author: Junchi Zhao
     */
    validUpload() {
      if (Object.keys(this.fileTasks).length > 0) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * @description: 进度
     * @param {*} event
     * @param {*} file
     * @param {*} fileList
     * @return {*}
     * @author: Junchi Zhao
     */
    onProgress(event, file, fileList) {},
    /**
     * @description: 删除文件
     * @param {*} file
     * @param {*} index
     * @return {*}
     * @author: Junchi Zhao
     */
    deleteFile(file, index) {
      if (this.fileTasks[file.uid]) {
        _.unset(this.fileTasks, file.uid);
        this.$refs.upload.abort(file);
      }
      if (index === -1) return;
      this.value.splice(index, 1);
    },
    /**
     * @description: 判断是否图片
     * @param {*} fileName
     * @return {*}
     * @author: Junchi Zhao
     */
    isPicture(fileName) {
      if (!fileName) {
        return false;
      } else {
        return /\.(bmp|jpg|jpeg|png|GIF|BMP|JPG|PNG)$/.test(fileName);
      }
    },
    downloadFile(path, name = "文件") {
      const xhr = new XMLHttpRequest();
      xhr.open("get", path);
      xhr.responseType = "blob";
      xhr.send();
      xhr.onload = function() {
        if (this.status === 200 || this.status === 304) {
          // 如果是IE10及以上，不支持download属性，采用msSaveOrOpenBlob方法，但是IE10以下也不支持msSaveOrOpenBlob
          if ("msSaveOrOpenBlob" in navigator) {
            navigator.msSaveOrOpenBlob(this.response, name);
            return;
          }
          // const blob = new Blob([this.response], { type: xhr.getResponseHeader('Content-Type') });
          // const url = URL.createObjectURL(blob);
          const url = URL.createObjectURL(this.response);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.jh-big-file-upload {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/upload/index.vue